import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../styles/constants';

export const useLinkStyles = makeStyles({
	root: {
		color: props => props.color || COLORS.LINK,
		'&:hover': {
			cursor: 'pointer'
		}
	}
});
